import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimText',
  pure: true,
})
export class TrimTextPipe implements PipeTransform {

  public transform(value: string, length: number): string {
    return value.length < length ? value : value.slice(0, length - 3).padEnd(length, '...');
  }
}
